import {Component, input, signal} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {finalize, from, Observable, take} from "rxjs";
import {NgClass} from "@angular/common";

@Component({
  selector: 'homey-submit-button',
  imports: [
    ButtonModule,
    NgClass
  ],
  templateUrl: './submit-button.component.html',
  standalone: true,
  styleUrl: './submit-button.component.scss'
})
export class SubmitButtonComponent {
  loading = signal(false);
  dt = input<object>();
  size = input<"small" | "large">();
  disabled = input<boolean>(false);
  text = input<boolean>(false);
  canSubmitFunction = input<() => boolean>(() => true);
  submitFunction = input.required<() => Observable<unknown> | Promise<unknown>>();
  submitButtonLabel = input.required<string>();
  severity = input<"success" | "info" | "warn" | "danger" | "help" | "primary" | "secondary" | "contrast">('primary');
  styleClass = input<string>('w-full min-w-[6rem]');

  onClick() {
    if (this.loading()) return;

    this.canSubmitFunction()();

    this.loading.set(true);

    let observable: Observable<unknown>;

    try {
      const result = this.submitFunction()();
      if (result instanceof Observable) {
        observable = result;
      } else {
        observable = from(result);
      }

      observable.pipe(
        take(1),
        finalize(() => {
          this.loading.set(false)
          console.log("Loading finished")
        })
      ).subscribe()
    } catch (e: unknown) {
      this.loading.set(false);
      throw e;
    }
  }
}
